module.exports = __webpack_public_path__ + "media/images/front/home/cards/card_4-e812f84e9c9b974df74c6ddb4ae16842.jpg";